// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style-module-membershipLevelDisplay-1DQ19{font-size:12px;font-weight:var(--weight-bold);color:#979797}@media(min-width: 960px){.style-module-membershipLevelDisplay-1DQ19{font-size:18px}}.header__container--dark .style-module-membershipLevelDisplay-1DQ19{color:#fff}", ""]);
// Exports
exports.locals = {
	"membershipLevelDisplay": "style-module-membershipLevelDisplay-1DQ19"
};
module.exports = exports;
